import {filter, isEmpty, omitBy} from 'lodash';

import {createResourceTableUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {ChannelModel} from '../../../models/api/channelModel';
import {AppAction} from '../../appActions';
import {deleteFromResourceTable, ResourceTable} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {InboxesActionsEnum} from '../inboxes/inboxesActions';
import {ChannelsActionsEnum} from './channelsActions';

/*
 * Reducer.
 */

const channelsUpdatedReducer = createResourceTableUpdatedReducer('channels', (channel) => channel.id);

export function channelsReducer(
  state: ResourceTable<number, ChannelModel>,
  action: AppAction,
): ResourceTable<number, ChannelModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return channelsUpdatedReducer(state, action);

    // Single channel deletion.
    case ChannelsActionsEnum.CHANNEL_DELETED:
      return deleteFromResourceTable(state, action.payload);

    // Single inbox deletion.
    case InboxesActionsEnum.INBOX_DELETED: {
      const newDeletedIds = filter(state.byId, (c) => c?.inboxId === action.payload).map(
        (c) => c?.id,
      ) as ReadonlyArray<number>;

      if (isEmpty(newDeletedIds)) {
        return state;
      }

      return {
        ...state,
        byId: omitBy(state.byId, (c) => c && newDeletedIds.includes(c.id)),
        deletedIds: state.deletedIds.merge(newDeletedIds),
      };
    }

    default:
      return state;
  }
}
